import { useSearchParams } from 'react-router-dom'

import {
    FilterContext,
    UpdateFilterParams,
    UpdateFilterValues,
} from '../context'
import type { FilterProviderProps } from './types'

export const FilterProvider = ({ children }: FilterProviderProps) => {
    const [searchParams, setSearchParams] = useSearchParams()

    // This function will update the filters either individually or in batch
    const updateFilter = (
        keys: UpdateFilterParams,
        values: UpdateFilterValues
    ) => {
        const newParams = new URLSearchParams(searchParams)

        if (Array.isArray(keys) && Array.isArray(values)) {
            // Batch update logic
            keys.forEach((key, index) => {
                const value = values[index]
                if (value) {
                    newParams.set(key, value)
                } else {
                    newParams.delete(key)
                }
            })
        } else if (typeof keys === 'string' && typeof values === 'string') {
            // Single update logic
            if (values) {
                newParams.set(keys, values)
            } else {
                newParams.delete(keys)
            }
        }

        // Update the searchParams (URL)
        setSearchParams(newParams)
    }

    const getFilterValue = (key: string) => {
        return searchParams.get(key)
    }

    const resetFilterValue = () => {
        const newParams = new URLSearchParams()
        setSearchParams(newParams)
    }

    return (
        <FilterContext.Provider
            value={{ updateFilter, getFilterValue, resetFilterValue }}
        >
            {children}
        </FilterContext.Provider>
    )
}
